import type { ReactNode } from "react";
import { cn } from "@/lib/utils";

export interface Detail {
  label: ReactNode;
  value: ReactNode;
  /** DM Mono: ids, codes, times. */
  mono?: boolean;
  /** Secondary text colour for the value. */
  muted?: boolean;
}

interface Props {
  items: Detail[];
  /** Two label/value pairs per line on wide screens. */
  columns?: 1 | 2;
  className?: string;
}

/** Facts about one thing, label beside value — what a two-column table was
 * used for before, without pretending to be a table. */
export function DetailList({ items, columns = 1, className }: Props) {
  return (
    <dl
      data-slot="detail-list"
      className={cn(
        "grid grid-cols-[minmax(0,auto)_minmax(0,1fr)]",
        columns === 2 && "lg:grid-cols-[minmax(0,auto)_minmax(0,1fr)_minmax(0,auto)_minmax(0,1fr)]",
        className,
      )}
    >
      {items.map((item, index) => (
        <div key={index} className="contents">
          <dt className="border-b border-line py-2 pr-6 text-muted-foreground">{item.label}</dt>
          <dd
            className={cn(
              "m-0 border-b border-line py-2 pr-6 break-words",
              item.mono && "data-mono",
              item.muted && "text-muted-foreground",
            )}
          >
            {item.value}
          </dd>
        </div>
      ))}
    </dl>
  );
}
